import { render, staticRenderFns } from "./OperaBettingLogWindow.vue?vue&type=template&id=8609e95a&"
import script from "./OperaBettingLogWindow.vue?vue&type=script&lang=js&"
export * from "./OperaBettingLogWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports